/**
 * Creative controls for the flavour voyage.
 *
 * These durations do not control scroll locking or UI feedback. You can make
 * the atmosphere slower without making the interaction feel unresponsive.
 */
export const FLAVOUR_TRANSITION_TUNING = {
  /** Ambient layers, palette and celestial-body hand-off. */
  backgroundTransitionDurationMs: 1_800,
  /** Slower crossfade used only between Origin and the flavour intro. */
  originHandoffDurationMs: 2_800,
  /** The can always travels the full arc with its own independent timing. */
  canArcDurationMs: 1_000,
  canArcDegrees: 40,
  /** Captures the deck as the end of the intro reaches this viewport point. */
  introActivationViewportRatio: 0.98,
  /** Deterministic resting point for the end of the intro after capture. */
  introAnchorViewportRatio: 0.96,
  desktopForwardInputs: 10,
  mobileForwardInputs: 3,
  backwardInputs: 1,
  chargeIdleMs: 1_500,
} as const
